/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostSptoolsFormInput = {|
  address: string,
  email: string,
  firstname: string,
  invoiceNumber: string,
  phone: string,
  reason: string,
  surname: string,
|};
export type PostSptoolsFormMutationVariables = {|
  input: PostSptoolsFormInput
|};
export type PostSptoolsFormMutationResponse = {|
  +postSptoolsForm: ?{|
    +result: ?boolean
  |}
|};
export type PostSptoolsFormMutation = {|
  variables: PostSptoolsFormMutationVariables,
  response: PostSptoolsFormMutationResponse,
|};
*/


/*
mutation PostSptoolsFormMutation(
  $input: PostSptoolsFormInput!
) {
  postSptoolsForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostSptoolsFormPayload",
    "kind": "LinkedField",
    "name": "postSptoolsForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostSptoolsFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostSptoolsFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "65555e504e408ea380fae0d1edd17e95",
    "id": null,
    "metadata": {},
    "name": "PostSptoolsFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostSptoolsFormMutation(\n  $input: PostSptoolsFormInput!\n) {\n  postSptoolsForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91e28949bda3be9690c81dc0aadf2e10';

module.exports = node;
